import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import SideBarClients from "./SideBarClient";
import AddIcon from "@mui/icons-material/Add";
import { isMobile, isTablet } from "react-device-detect"; // Import isTablet

const CircularButton = ({
  handleToggleSidebar,
  setClientActive,
  openPopup,
  activeClientId,
  syncContacts,
  setActiveClientInformation,
  activeClientInformation,
  setOpenSidebarClient,
  openPopupState,
  openSidebarClient,
}) => {
  const [open, setOpen] = useState(openSidebarClient);

  const handleCloseSidebar = () => {
    setOpen(false);
  };

  return (
    // <div
    // // className={`sidebar-client-div ${
    // //   openSidebarClient ? "" : "close-client-div"
    // // }`}
    // >

    // </div>
    <SideBarClients
      syncContacts={syncContacts}
      openPopupState={openPopupState}
      openSidebarClient={openSidebarClient}
      setOpenSidebarClient={setOpenSidebarClient}
      activeClientInformation={activeClientInformation}
      setActiveClientInformation={setActiveClientInformation}
      setClientActive={setClientActive}
      handleToggleSidebar={handleToggleSidebar}
      close={handleCloseSidebar}
      openPopup={openPopup}
    />
  );
};

export default CircularButton;
